import path from 'node:path';
import fs from 'node:fs';
import type { ListEntry } from './types.js';

export async function mapDirEntry(
  d: fs.Dirent,
  relativePath: string,
  resolved: string,
): Promise<ListEntry> {
  const entryPath = path.join(relativePath || '.', d.name).replace(/\\/g, '/');
  const fullPath = path.join(resolved, d.name);
  let isDir = d.isDirectory();
  if (d.isSymbolicLink()) {
    try {
      const targetStat = await fs.promises.stat(fullPath);
      isDir = targetStat.isDirectory();
    } catch {
      isDir = false;
    }
  }
  return {
    name: d.name,
    path: entryPath,
    isDir,
    isSymlink: d.isSymbolicLink(),
  };
}
